import createReactComponent from '../createReactComponent';
export default createReactComponent('room-service', 'RoomService', [["path",{"d":"M12 6.167V4m0 2.167a8 8 0 0 1 8 8V17H4v-2.833a8 8 0 0 1 8-8M3 20h18","key":"svg-0"}]]);